import React from 'react';
import { TrendingUp, Award, Percent } from 'lucide-react';

/**
 * StatsPanel Component - Detailed statistics display
 *
 * Shows mining performance metrics:
 * - Win rate
 * - Total mined
 * - ROI
 *
 * This component is standalone and can be easily customized.
 */
export default function StatsPanel({ winRate, totalMined, roi, totalRounds = 0 }) {
    return (
        <div className="grid grid-cols-3 gap-4">
            {/* Win Rate */}
            <div className="bg-purple-500/10 border border-purple-500/30 rounded-lg p-4 text-center transition-all hover:bg-purple-500/20">
                <div className="flex items-center justify-center mb-2">
                    <Percent className="text-purple-400" size={20} />
                </div>
                <div className="text-xs text-gray-400 mb-1">Win Rate</div>
                <div className="text-2xl font-bold text-purple-400">
                    {winRate.toFixed(0)}%
                </div>
                <div className="text-xs text-gray-500 mt-1">
                    {totalRounds} rounds
                </div>
            </div>

            {/* Total Mined */}
            <div className="bg-orange-500/10 border border-orange-500/30 rounded-lg p-4 text-center transition-all hover:bg-orange-500/20">
                <div className="flex items-center justify-center mb-2">
                    <Award className="text-orange-400" size={20} />
                </div>
                <div className="text-xs text-gray-400 mb-1">Total Mined</div>
                <div className="text-2xl font-bold text-orange-400">
                    {totalMined.toFixed(2)}
                </div>
                <div className="text-xs text-gray-500 mt-1">
                    MINER tokens
                </div>
            </div>

            {/* ROI */}
            <div className={`${
                roi >= 0 ? 'bg-green-500/10 border-green-500/30' : 'bg-red-500/10 border-red-500/30'
            } border rounded-lg p-4 text-center transition-all hover:opacity-90`}>
                <div className="flex items-center justify-center mb-2">
                    <TrendingUp className={roi >= 0 ? 'text-green-400' : 'text-red-400'} size={20} />
                </div>
                <div className="text-xs text-gray-400 mb-1">ROI</div>
                <div className={`text-2xl font-bold ${roi >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                    {roi >= 0 ? '+' : ''}{roi.toFixed(0)}%
                </div>
                <div className="text-xs text-gray-500 mt-1">
                    {roi >= 0 ? 'Profit' : 'Loss'}
                </div>
            </div>
        </div>
    );
}
